import React from 'react';
import { RenderPage } from '@/src/render';
import { About } from './components/About';
import { Provider } from 'react-redux';
import { store } from '@/src/store/configure';
import { BrowserRouter } from 'react-router-dom';
import { AboutSectionShimmerLoader } from './ShimmerLoader';

export const AboutSection = () => {
  const cocode = document
    .getElementById('csr-stock-about-section')
    ?.getAttribute('data-cocode');
  const companyName = document
    .getElementById('csr-stock-about-section')
    ?.getAttribute('data-company-name');
  if (!cocode) {
    return (
      <>
        <AboutSectionShimmerLoader />
      </>
    );
  } else {
    return (
      <>
        <About cocode={String(cocode)} companyName={String(companyName)} />
      </>
    );
  }
};

RenderPage(
  'csr-stock-about-section',
  <Provider store={store}>
    <BrowserRouter>
      <AboutSection />
    </BrowserRouter>
  </Provider>,
);
